import React from 'react';

import styles from 'stylesheets/components/placeholders/book_card_condensed_placeholder.module';

export function BookCardCondensedPlaceholder() {
  return (
    <div className={styles.bookCardCondensedPlaceholder}>
      <div className={styles.coverPlaceholder}>
        <div className={styles.coverImage}></div>
      </div>
      <div className={styles.pricingPlaceholder}></div>
    </div>
  );
}
